import React from "react";
import { useTranslation } from "react-i18next";
import FormInput from "src/components/Common/Form/FormInput";
import { FORM_NAME, PATTERN_NUMBER } from "src/constant/common";

const TVCSigma = ({ register, errors }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  return (
    <div className="row">
      <h3 className="mcs-block-title">{t("new.MCS.tvc_sigma_title")}</h3>
      <div className="col-md-6">
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.TVC_ACTUATOR_NATURAL_FREQUENCY}`)}
          name={`MCS.${FORM_NAME.MCS.TVC_ACTUATOR_NATURAL_FREQUENCY}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.TVC_ACTUATOR_NATURAL_FREQUENCY}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.TVC_ACTUATOR_NATURAL_FREQUENCY]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.TVC_ACTUATOR_NATURAL_FREQUENCY}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.TVC_ACTUATOR_NATURAL_FREQUENCY}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.TVC_ACTUATOR_NATURAL_FREQUENCY}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.TVC_ACTUATOR_FREQUENCY}`)}
          name={`MCS.${FORM_NAME.MCS.TVC_ACTUATOR_FREQUENCY}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.TVC_ACTUATOR_FREQUENCY}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.TVC_ACTUATOR_FREQUENCY]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.TVC_ACTUATOR_FREQUENCY}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.TVC_ACTUATOR_FREQUENCY}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.TVC_ACTUATOR_FREQUENCY}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.MINIMUM_TVC_DEFLECTION}`)}
          name={`MCS.${FORM_NAME.MCS.MINIMUM_TVC_DEFLECTION}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.MINIMUM_TVC_DEFLECTION}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.MINIMUM_TVC_DEFLECTION]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.MINIMUM_TVC_DEFLECTION}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.MINIMUM_TVC_DEFLECTION}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.MINIMUM_TVC_DEFLECTION}`) })}
          unit="rad"
        />
      </div>
      <div className="col-md-6">
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.DAMPING_RATIO}`)}
          name={`MCS.${FORM_NAME.MCS.DAMPING_RATIO}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.DAMPING_RATIO}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.DAMPING_RATIO]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.DAMPING_RATIO}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.DAMPING_RATIO}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.DAMPING_RATIO}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.MAXIMUM_TVC_DEFLECTION}`)}
          name={`MCS.${FORM_NAME.MCS.MAXIMUM_TVC_DEFLECTION}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.MAXIMUM_TVC_DEFLECTION}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.MAXIMUM_TVC_DEFLECTION]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.MAXIMUM_TVC_DEFLECTION}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.MAXIMUM_TVC_DEFLECTION}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.MAXIMUM_TVC_DEFLECTION}`) })}
          unit="rad"
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.MAXIMUM_TVC_DEFLECTION_LIMIT}`)}
          name={`MCS.${FORM_NAME.MCS.MAXIMUM_TVC_DEFLECTION_LIMIT}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.MAXIMUM_TVC_DEFLECTION_LIMIT}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.MAXIMUM_TVC_DEFLECTION_LIMIT]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.MAXIMUM_TVC_DEFLECTION_LIMIT}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.MAXIMUM_TVC_DEFLECTION_LIMIT}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.MAXIMUM_TVC_DEFLECTION_LIMIT}`) })}
          unit="rad/s"
        />
      </div>
    </div>
  );
};

export default TVCSigma;
